import { Entity } from '@data-client/rest';
class DashboardTypeEntity extends Entity {
    constructor() {
        super(...arguments);
        this.organizationId = 0;
        this.type = 'SINGLE';
    }
    pk() {
        return btoa(JSON.stringify(this));
    }
}
DashboardTypeEntity.key = 'DashboardType';
export { DashboardTypeEntity };
